import { galleryStatus } from '~constants/gallery';

export const fileStatusCondition = (file, statusFilter) => {
  let statusCondition = null;

  switch (statusFilter) {
    case 'all_content':
      statusCondition = true;
      break;
    case 'draft':
      statusCondition = file.status === galleryStatus.EXTERNAL_NEW || !file.status;
      break;
    case 'pending_approval':
      statusCondition = file.status === galleryStatus.PENDING || !file.status;
      break;
    case 'published':
      statusCondition = file.status === galleryStatus.APPROVED || !file.status;
      break;
    case 'rejected':
      statusCondition = file.status === galleryStatus.REJECTED || !file.status;
      break;
    default:
      statusCondition = true;
  }

  return statusCondition;
};

export const other = () => {};
